import { styled } from '@uhg-abyss/web/tools/styled';

export const HeaderContainer = styled('div', {
  backgroundColor: '$bgProviderDetailsColor',
  maxWidth: '1200px',
  marginLeft: 'auto',
  marginRight: 'auto',
  paddingTop: '$sm',
  paddingLeft: '$lg',
  paddingRight: '$lg',
});

export const careTeamHeaderStyle = {
  'abyss-heading-root': {
    fontFamily: '$heading',
    margin: '0',
    paddingTop: '$sm !important',
    paddingBottom: '$md !important',
    display: 'inline-block',
    '@media (max-width: 744px)': {
      fontSize: '$largeText !important',
      lineHeight: '$md !important',
    },
  },
};

export const HeaderPageWrapper = styled('div', {
  backgroundColor: '$bgHeaderColor',
  paddingTop: '70px !important',
  paddingBottom: '50px !important',
  borderBottom: '1px solid $greyBorderColor',
});
